;(function($){

  $(window).ready(init);

  function init() {
    var HEROHOME = '.HeroHome';

    function giveHeroSize(){
      var height = $(window).height() - 80;
      $(HEROHOME).height(height);
    }

    giveHeroSize();

    $(window).on('resize', function(){
      giveHeroSize();
    })
  }

})(jQuery);
